export const ALGO = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#242424" />
    <g clipPath="url(#clip0_1_3243)">
      <path
        d="M9.29863 25.085L12.0587 20.3053L14.8188 15.5425L17.562 10.7628L18.0165 10.0055L18.2184 10.7628L19.0599 13.91L18.1174 15.5425L15.3574 20.3053L12.6141 25.085H15.9127L18.6728 20.3053L20.1033 17.8313L20.7765 20.3053L22.0556 25.085H25.0176L23.7386 20.3053L22.4595 15.5425L22.1229 14.3139L24.1761 10.7628H21.1805L21.0795 10.4094L20.036 6.50489L19.9014 6H17.0235L16.9562 6.10098L14.2634 10.7628L11.5033 15.5425L8.76008 20.3053L6 25.085H9.29863Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3243">
        <rect
          width="19.0176"
          height="19.085"
          fill="white"
          transform="translate(6 6)"
        />
      </clipPath>
    </defs>
  </svg>
);
